<template>
  <div :class="['comp-fh-condition-person', { 'is-error': isError, 'is-disabled': disabled }, className]">
    <!-- {{}} -->
    <jw-trigger :disabled="disabled" trigger="click" update-at-scroll :popup-translate="position ? [0, 0] : [-8, 0]" :position="position" @popup-visible-change="selectVisibleChange">
      <slot>
        <div class="person-show">
          <template v-if="selectedList.length">
            <div class="person-show-item" v-for="(item, index) in selectedList.slice(0, maxTagCount)" :key="item.id">
              <xl-avatar :avatar="{ name: item?.userName || item?.name || '', url: item?.avatar || item?.avatarOrigin, id: item?.userId || item?.id }" :size="16" />
              <div class="closable" v-if="!disabled" @click.stop="delPerson(index)"><icon-close size="12" /></div>
            </div>
            <div v-if="selectedList.length > maxTagCount" class="person-show-item more-count">+{{ selectedList.length - maxTagCount }}...</div>
          </template>
          <template v-else>
            <div class="person-show-empty" :class="{ 'is-disabled': disabled }">请选择</div>
          </template>
        </div>
      </slot>
      <template #content>
        <div class="person-list">
          <div class="personnel-edit-content" :style="{ width: popupWidth ? `${popupWidth}px` : '280px' }">
            <div class="search-content">
              <jw-input placeholder="搜索人员" allow-clear v-model.trim="data.listParams.keyword" @clear="onSearchInput" @input="onSearchInput" @press-enter="onSearchInput" ref="searchRef" />
            </div>
            <div class="personnel-list-content">
              <jw-list
                @reach-bottom="loadMoreData"
                :bordered="false"
                :split="false"
                :data="data.records"
                :scrollbar="false"
                :virtualListProps="{
                  height: 240
                }"
                :loading="data.loading"
              >
                <template #item="{ item }">
                  <jw-list-item :key="item.id">
                    <div class="personnel-item-content" @click="selectItem(item)">
                      <div class="personnel-item">
                        <div class="personnel-avatar">
                          <div class="personnel-avatar-list">
                            <!-- 有头像 -->
                            <jw-avatar :size="32" v-if="item?.avatar || item?.avatarOrigin">
                              <img :alt="item?.userName || item?.name || ''" :src="item?.avatar || item?.avatarOrigin" />
                            </jw-avatar>
                            <template v-else>
                              <jw-avatar :size="32">
                                <span>{{ item?.userName || item?.name?.slice(item?.userName || item?.name?.length - 2) }}</span>
                              </jw-avatar>
                            </template>
                          </div>
                          <div class="personnel-name-list">
                            <span class="avatar-name" :title="item?.userName || item?.name">{{ item?.userName || item?.name }}</span>
                            <div v-if="item?.departmentName" class="dep-name"><xl-label-text :value="item.departmentName" :row="1" fontSize="12px" /></div>
                          </div>
                        </div>
                      </div>
                      <div class="personnel-radio-content">
                        <icon-check-circle-fill v-if="isSelected(item)" class="selected-icon" />
                      </div>
                    </div>
                  </jw-list-item>
                </template>
                <template #empty>
                  <xl-empty v-if="!data.loading && !data.records?.length" class="empty-text" :msg="$t('没有找到匹配的数据')"></xl-empty>
                  <!-- 触发器 -->
                  <div v-else :style="{ height: '150px' }"></div>
                </template>
              </jw-list>
            </div>
          </div>
        </div>
      </template>
    </jw-trigger>
    <jw-button class="person-add-btn" @click.stop="openTreeMemberModalRef" v-if="!disabled">
      <template #icon>
        <icon-plus />
      </template>
    </jw-button>
  </div>
  <xl-tree-member-modal ref="treeMemberModalRef" style="display: none" :tree="userTree" @cb="getValUser($event, index, i)" :multipleDep="multiple" :user="selectedList"><div /></xl-tree-member-modal>
</template>

<script setup>
import { reactive, ref, computed, nextTick, watch } from 'vue';
import { publicService } from '@/api/';
import { tools } from '@/utils/tools';
import { Message } from '@arco-design/web-vue';

const props = defineProps({
  item: {
    type: Object,
    default: () => {
      return {};
    }
  },
  maxTagCount: {
    type: [Number, String],
    default: 2
  },
  popupWidth: {
    type: [Number, String],
    default: 0
  },
  isError: {
    type: Boolean,
    default: false
  },
  position: {
    type: String,
    default: 'bottom'
  },
  multiple: {
    type: Boolean,
    default: false // 是否多选
  },
  disabled: {
    type: Boolean,
    default: false // 是否禁用
  },
  className: {
    type: String,
    default: ''
  },

  triggerType: {
    // 触发方式
    type: String,
    default: 'click',
    validator: (value) => {
      return ['click', 'close'].includes(value);
    }
  },
  maxNumber: {
    // 最多可选数量
    type: Number,
    default: null
  }
});

const user = computed(() => {
  return props.modulesItem;
});

console.log('props.modulesItem3333', user.value);
const searchRef = ref(null);
const selectedList = ref([]); // 选中的人员列表
const data = reactive({
  records: [],
  listParams: {
    page: 1,
    pageSize: 20,
    keyword: ''
  },
  loading: false,
  hasMore: true
});

const treeMemberModalRef = ref();
const userTree = ref({
  checkDepartment: false,
  isAll: false
});

const openTreeMemberModalRef = () => {
  treeMemberModalRef.value.openDialog();
};

//是否选中
const isSelected = (item) => {
  return !!selectedList.value?.find((itemVal) => itemVal.id == item.id);
};

// 获取数据
const fetchData = async (reset = false) => {
  if (data.loading) return;
  // 重置状态
  if (reset) {
    data.loading = true;

    data.hasMore = true;
    data.listParams.page = 1;
  } else {
    // 如果不是重置且没有更多数据，直接返回
    if (!data.hasMore) return;
    data.loading = true;
  }

  try {
    const params = {
      ...data.listParams,
      keyword: data.listParams.keyword || undefined
    };

    const res = await publicService.getUserList(params);
    if (!res.error) {
      const result = res.result;
      const getResult = result?.records || [];

      data.hasMore = data.listParams.page < result?.pages;

      if (reset || data.listParams.page == 1) {
        data.records = getResult;
      } else {
        // 使用Set去重，避免重复数据
        const uniqueIds = new Set(data.records.map((item) => item.id));
        const newRecords = getResult.filter((item) => !uniqueIds.has(item.id));
        data.records = [...data.records, ...newRecords];
      }
      data.listParams.page++;
    }
  } catch (e) {
    console.log(e);
    data.loading = false;
  } finally {
    data.loading = false;
  }
};

// 搜索输入处理（防抖）
const onSearchInput = tools.debounceFn(
  () => {
    fetchData(true);
  },
  300,
  false
);

// 删除人员
const delPerson = (index) => {
  selectedList.value.splice(index, 1);
  updateValue();
  emits('remove', {
    userList: selectedList.value,
    departList: []
  });
};

const getValUser = (v) => {
  selectedList.value = v.userList;
  updateValue();
};

// 选择数据
const selectItem = (item) => {
  const userItem = {
    avatar: item.avatar || item.avatarOrigin,
    avatarOrigin: item.avatar || item.avatarOrigin,
    id: item.id || item.userId,
    name: item.name || item.userName,
    userName: item.name || item.userName
  };

  if (props.multiple) {
    //多选
    const findIndex = selectedList.value.findIndex((itemVal) => itemVal.id == item.id);
    if (findIndex > -1) {
      selectedList.value.splice(findIndex, 1);
    } else {
      if (props.maxNumber && selectedList.value.length >= props.maxNumber) {
        Message.error(`最多可选人数为${props.maxNumber}人`);
        return;
      }
      //选中
      selectedList.value.push({ ...userItem });
    }
  } else {
    selectedList.value = [{ ...userItem }];
  }

  if (props.triggerType === 'click') {
    updateValue();
  }
};

// 抛出数据
const emits = defineEmits(['cb', 'popup-visible-change', 'remove']);
const updateValue = () => {
  emits('cb', {
    userList: selectedList.value,
    departList: []
  });
};

// 选择人员弹窗显示状态
const selectVisibleChange = (visible) => {
  emits('popup-visible-change', visible);
  if (!visible && props.triggerType === 'close') {
    updateValue();
  }

  if (visible) {
    nextTick(() => {
      searchRef.value?.focus();
    });
  }
};

//加载更多
const loadMoreData = () => {
  fetchData(false);
};

// 存在二次更新场景，查找关联，计算字段，默认值赋值
watch(
  () => props.item,
  (newVal) => {
    // 如果没有 fieldValueConfig，直接判断 userList
    if (newVal?.userList) {
      selectedList.value = newVal.userList;
    }
  },
  {
    deep: true,
    immediate: true
  }
);
</script>
<style scoped lang="less">
@import './fh-person.less';
</style>
